import {defaultProviders, boot} from "./app/shared/utils/bootstrap.util";
import {bootstrap} from "@angular/platform-browser-dynamic";
import {App} from "./app/app.component";

boot(()=>bootstrap(App, defaultProviders));




/** WEBPACK FOOTER **
 ** ./client/client.main.ts
 **/